import { AssetCategory, AssetList } from "../../Types/state/masterdata";

export interface IState {
  assets: AssetList[];
  assetsCount: number;
  assetsCategories: AssetCategory[];
  singleAssets: any;
  assetsLastId: any;
}

type Action = any;

export const assetsReducer = (
  state: IState = {
    assets: [],
    assetsCount: 0,
    assetsCategories: [],
    singleAssets: {},
    assetsLastId: "",
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_ASSETS":
      return {
        ...state,
        assets: action?.payload?.page == 1 ? action?.payload?.data : [...state?.assets, ...action?.payload?.data],
        assetsCount: action?.payload?.count,
      };
    case "GET_SINGLE_ASSETS":
      return {
        ...state,
        singleAssets: action?.payload[0],
      };
    case "UPDATE_ASSETS":
      return {
        ...state,
        assets: state?.assets?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };

    case "GET_ASSETS_CATEGORIES":
      return {
        ...state,
        assetsCategories:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.assetsCategories, ...action?.payload?.data],
      };

    case "DELETE_ASSETS":
      return {
        ...state,
        assets: state?.assets?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "GET_ASSETS_ID":
      return {
        ...state,
        assetsLastId: action?.payload + 1,
      };

    case "CREATE_ASSETS_SERVICE":
      const updatedAssets = {
        ...state?.singleAssets,
        asset_service: [...state?.singleAssets?.asset_service, action.payload],
      };

      return {
        ...state,
        singleAssets: updatedAssets,
      };

    case "DELETE_ASSETS_CATEGORY":
      return {
        ...state,
        assetsCategories: state?.assetsCategories?.filter((elem: any) => elem?._id !== action?.payload),
      };

    case "ADD_ASSETS_COMPONENT_DATA":
      const sindleupdatedAssets = {
        ...state?.singleAssets,
        inventory_id: [...state?.singleAssets?.inventory_id, action.payload],
      };
      return {
        ...state,
        singleAssets: sindleupdatedAssets,
      };
    case "UPDATE_ASSET_CATEGORY":
      return {
        ...state,
        assetsCategories: state?.assetsCategories?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };

    case "RESTORE_AND_PERMANENT_DELETE_ASSET_CATEGORY":
      return {
        ...state,
        assetsCategories: state?.assetsCategories?.filter((elem: any) => elem?._id !== action?.payload),
      };

    default:
      return state;
  }
};
